<script lang="ts">
	import {
		calculateGroups,
		Group,
		homebrewProgression,
		setCharacterBonus,
	} from "./group";

	import {
		Character,
		characterStore,
		initCharacter,
	} from "../character/character";

import AttributeTableToggle from "../attribute/AttributeTableToggle.svelte";

	let character: Character = initCharacter();

	characterStore.subscribe((updateCharacter) => {
		console.log("Groups.subscribe", updateCharacter);

		character = updateCharacter;
		character.groups = setCharacterBonus(
			character.groups,
			character.characterAttributes
		);

		character.groups = calculateGroups(character.groups, character.profession)
			.map(g => homebrewProgression(g,"8", character.progressions.bodyList))
			.map(g => homebrewProgression(g,"15", character.progressions.magicList));
	});

	function updateValue(index: number, group: Group) {
		character.groups[index] = group;
		characterStore.set(character);
	}

	let toggles = []
	let toggle = false;

</script>

<main>
	<h2>Gruppen</h2>

		<table>
			<thead>
				<th on:click={() =>{
					toggle = !toggle
					toggles.forEach(t => t.display(toggle))
				}}>
					{toggle ? "+" : "-"}
				</th>
				<th>ID</th>
				<th>Name</th>
				<th>Rang</th>

				<th>Objekt</th>
				<th>Spezial</th>
				<th>Total</th>
			</thead>


			{#each character.groups as group, index}
				<AttributeTableToggle 
					bind:this={toggles[index]}
					group={group}
					changeFn={() => updateValue(index, group)}
				></AttributeTableToggle>
			{/each}


		</table>
</main>
